function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m36.3149 2.1903-12.8725 22.296 1.9775 1.1417-1.8522 3.1978-1.9731-1.1392-1.3556 2.3481-3.1978-1.8376 1.3594-2.3545-2.0169-1.1645 1.8522-3.1978 2.0124 1.1619 12.8688-22.2895 3.1978 1.8376zm-29.6259 40.1511h48.9025c2.1275 0 3.8515-1.7242 3.8515-3.8515h3.7042c0 4.1723-3.3832 7.5557-7.5557 7.5557h-48.9025zm-6.2473-7.5065h48.9026c2.1274 0 3.8514-1.7243 3.8514-3.8515h3.7042c0 4.1722-3.383 7.5557-7.5556 7.5557h-48.9026v-3.7042zm47.7199-29.3466-12.8725 22.296 1.9775 1.1417-1.8522 3.1978-1.9731-1.1392-1.3556 2.3481-3.1978-1.8376 1.3594-2.3545-2.0169-1.1645 1.8522-3.1978 2.0124 1.1619 12.8688-22.2895z",
  fill: "#015168",
  fillRule: "nonzero"
});

var SvgLatuhiihto = function SvgLatuhiihto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "46.5666mm",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 63.5 46.5666",
    width: "63.5mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLatuhiihto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/latuhiihto.c2936aec.svg";
export { ForwardRef as ReactComponent };